<template>
  <div class="address-wrap" @click.stop="">
    <span>配送至：</span>
    <div v-if="address && address.receiverName" class="adressBox">
      <div v-if="address.isDefault" class="defTab">
        默认
      </div>
      <div class="item">
        {{ address.receiverName }}
      </div>
      <div class="item">
        {{ address.province }}
      </div>
      <div class="item">
        {{ address.city }}
      </div>
      <div class="item">
        {{ address.county }}
      </div>
      <div class="item">
        {{ address.receiptAddress }}
      </div>
      <div class="item">
        {{ address.receiverPhone }}
      </div>
    </div>
    <el-button v-if="address && address.receiverName" type="text" class="btn-wrap" @click.stop="selectAddress">
      更改地址
    </el-button>
    <el-button v-else type="text" class="btn-wrap" @click.stop="selectAddress">
      选择地址
    </el-button>
    <span style="margin-left: 20px;">特殊发货需求：</span>
    <el-select v-model="multiaddress" placeholder="请选择" @change="(val) => $emit('multiaddressChange', val)">
      <el-option
        v-for="item in warehouseList"
        :key="item.dictLabel"
        :label="item.dictValue"
        :value="item.dictLabel"
      />
    </el-select>
    <!-- <el-input
      v-if="multiaddress === '其他'"
      v-model="multiaddressValue"
      @click.native.stop="stopProp"
    /> -->

    <addressBox :prop-open.sync="isShow" @chooseAddress="changeAddress" @ChangeDatas="changeDatas" />
  </div>
</template>

<script>
import addressBox from '@/views/address/index.vue';
import { getReceiptAddressInfoModel } from '@/API';
import { getDictData } from '@/API/international';

export default {
  components: {
    addressBox
  },

  props: {
    data: {
      type: Object,
      default: () => {}
    },
    // 特殊开票需求默认值
    multiaddress: {
      type: [Object, String],
      default: ''
    }
  },

  data () {
    return {
      isShow: false,
      address: {},
      warehouseList: []
    };
  },

  created () {
    this.queryWarehouse();
  },

  watch: {
    data: {
      deep: true,
      handler (newval) {
        this.address = newval;
      }
    },
    multiaddress: {
      deep: true,
      handler (newval) {
        this.multiaddress = newval || '';
      }
    }
  },

  methods: {
    selectAddress () {
      this.$confirm('选择地址将覆盖全部产品地址，是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.isShow = true;
      }).catch((e) => {
        console.error(e);
      });
    },
    // 地址变更回到
    changeAddress (val) {
      // 选择其他地址
      this.address = val;
      this.isShow = false;
      this.$emit('chooseAddress', val);
    },

    // 地址选择 地址源地址列表发生变化，需要用当前地址id 重新查询地址信息
    changeDatas () {
      if (this.address.id) {
        getReceiptAddressInfoModel(this.address.id).then((res) => {
          let { status, data } = res.data;
          if (status === '200') {
            if (!data.isDelete) {
              this.address = data;
            } else {
              this.address = {};
            }
          }
        });
      }
    },
    queryWarehouse () {
      let params = { dictType: 'desc_of_special_requirements' };
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.warehouseList = data;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.address-wrap{
  display: inline-block;
}

.adressBox{
  display: inline-block;

  .item{
    display: inline-block;
    margin-right: 6px;
  }

  .defTab{
    padding: 3px 10px;
    display: inline-block;
    background: #1b73ff;
    font-size: 12px;
    color: #fff;
    border-radius: 4px;
    margin-right: 15px;
  }
}

.btn-wrap{
  padding: 0;
  margin-left: 15px
}
</style>
